import React from 'react';

// PROD-7828: the muted line under a teacher's name. Slug only — no email/uuid fallback (D-4 lineage).
const TeacherSlugLine = ({ slug }) =>
  slug ? <div className="tp-card-field-label">{slug}</div> : null;

export default TeacherSlugLine;
